export default "__VITE_ASSET__B9UZ6DHB__"